/**
 * useCook – wrapper around Nuxt `useCookie`
 * - defaults `watch:'shallow'`
 * - optional runtime console‑trace in dev mode for quick audit
 */

import { useCookie } from '#app/composables/cookie'
import { useNuxtApp } from '#app'

type UseCookieOptions = Parameters<typeof useCookie>[1]

export function useCook<T = string>(
  name: string,
  opts: UseCookieOptions = {}
) {
  // default watch → 'shallow'
  if (opts.watch === undefined) {
    opts = { ...opts, watch: 'shallow' }
  }

  // DEV‑only debug: log every call once per component render
  if (process.dev && (globalThis as any).__DEBUG_COOKIES__ !== false) {
    // console.log(
    //   `[useCook] ${name} | watch: ${opts.watch}`,
    //   new Error().stack?.split('\n').slice(2, 6).join(' → ')
    // )
  }

  return useCookie<T>(name, opts)
}

/**
 * Helper to toggle debug at runtime:
 *   import { toggleCookDebug } from '~/composables/useCook'
 *   toggleCookDebug(false) // disable
 */
export function toggleCookDebug(on = true) {
  ;(globalThis as any).__DEBUG_COOKIES__ = on
}

export default useCook